import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import cn from 'classnames';

import FavouriteStar from '../favouriteStar';


@withRouter
@inject('lineStore', 'routingStore')
@observer
class LiveMenuGame extends Component {
  static contextTypes = {
    sportId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    leagueId: PropTypes.number,
  }

  constructor(props) {
    super(props);
  }

  selectItem = (evt) => {
    const { lid, sid } = this.props.lineStore.menu.games.get(this.props.id);
    this.props.history.push(`/${this.props.lineStore.mode}/${sid}/${lid}/${this.props.id}`);
    // this.props.lineStore.menu.selectItem(this.props.id, this.props.type);
    evt.preventDefault();
  }

  toggle = () => {
    this.props.lineStore.menu.toggleOpenItem(this.props.id, this.props.type);
  }

  render() {
    const { games, selected } = this.props.lineStore.menu;
    const { id } = this.props;
    const data = games.get(id);
    const isSelected = selected.games.includes(id);
    const name = `${data.c1} ${data.c2 ? '- ' + data.c2 : ''}`
    // const name = ``


    if (!data) {
      return null;
    }

    const classNames = cn([
      'favourites-league-item',
      'favourites-game-item',
      { 'favourites-menu-item_active': isSelected },
    ]);

    return (
      <div className={classNames}>
        <FavouriteStar
          type={this.props.type}
          id={this.props.id}
        />
        <button
          title={name}
          onClick={this.selectItem}
          className="league-item-a game-item-a"
        >
          {name}
        </button>
      </div>
    );
  }
}

export default LiveMenuGame;




// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuGame.jsx